// Dependencies.
import Store from '../../store'

import sv from './sv.js'
import en from './en.js'

export default {
  // translate will take a string expected to be a key in the translation object included. If such a key exists, that
  // translation will be returned. If it does not exist, the string provided into the function will be returned.
  translate: function (string) {
    let lang = Store.getters.getCurrLanguage
    let translations

    switch (lang.iso) {
      case 'sv':
        translations = sv
        break
      default: // Default to English
        translations = en
        break
    }

    if (!translations) {
      return string
    }

    if (translations[string]) {
      return translations[string]
    }
    return string
  }
}



// WEBPACK FOOTER //
// ./src/filters/translate/index.js